import { X } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { StatementItemReference } from "@/payroll/ai-script/statement/statement-renderer";
import { referenceParts } from "@/payroll/pack-chat/reference-label";

/** The selected PayPack figure as it will read at the top of the new thread. */
export const AttachedStatementItem = ({
  item,
  onRemove,
}: {
  item: StatementItemReference;
  onRemove: () => void;
}) => {
  const { path, label, value, valueIsFigure } = referenceParts(item);
  const details = [path, valueIsFigure ? undefined : value]
    .filter(Boolean)
    .join(" · ");

  return (
    <Stack
      direction="row"
      align="center"
      justify="between"
      gap="md"
      fullWidth
      className="border-b border-stroke-tertiary pb-3"
    >
      <Stack gap="none" align="stretch" className="min-w-0">
        <Typography
          variant="bodyW3"
          textColor="tertiary"
          className="text-[11px] font-semibold uppercase tracking-wide"
        >
          Asking about
        </Typography>
        <Typography variant="subtitleW3" className="truncate">
          {label}
        </Typography>
        {details && (
          <Typography
            variant="bodyW3"
            textColor="secondary"
            className="truncate"
          >
            {details}
          </Typography>
        )}
      </Stack>
      <Stack direction="row" align="center" gap="sm" className="shrink-0">
        {value && valueIsFigure && (
          <Typography variant="subtitleW2">{value}</Typography>
        )}
        <button
          type="button"
          onClick={onRemove}
          aria-label="Remove the attached figure"
          className="rounded-full p-1 text-tertiary-text transition-colors hover:bg-surface-secondary hover:text-primary-text"
        >
          <X className="size-4" aria-hidden />
        </button>
      </Stack>
    </Stack>
  );
};
